import ResourceAdmin from "@/components/admin/ResourceAdmin";

const emptyItem = { name_ar: "", role_ar: "", quote_ar: "", rating: 5, order: 0, is_active: true };

export default function TestimonialsAdmin() {
  return (
    <ResourceAdmin
      title="آراء العملاء"
      resource="testimonials"
      testIdPrefix="admin-testimonials"
      emptyItem={emptyItem}
      columns={[
        { key: "name_ar", label: "الاسم" },
        { key: "role_ar", label: "المسمى" },
        {
          key: "rating", label: "التقييم",
          render: (r) => "★".repeat(r.rating || 0),
        },
        {
          key: "is_active", label: "الحالة",
          render: (r) => (
            <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${r.is_active ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-600"}`}>
              {r.is_active ? "مفعّل" : "معطّل"}
            </span>
          ),
        },
      ]}
      fields={[
        { name: "name_ar", label: "اسم العميل", type: "text" },
        { name: "role_ar", label: "المسمى/الشركة", type: "text" },
        { name: "quote_ar", label: "الرأي", type: "textarea", rows: 4 },
        { name: "rating", label: "التقييم (1-5)", type: "number", min: 1, max: 5 },
        { name: "order", label: "الترتيب", type: "number", min: 0 },
        { name: "is_active", label: "مفعّل", type: "checkbox" },
      ]}
    />
  );
}
